module.exports = __webpack_public_path__ + "img/iriomote_7.f6370cd7.jpg";